import { Viewer } from '@bytemd/react';
import 'bytemd/dist/index.css';
import React from 'react';
import { markdownPlugins } from './plugins';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  if (!content.trim()) {
    return null;
  }

  return <Viewer value={content} plugins={markdownPlugins} />;
};

export default MarkdownRenderer;
